import React, {ChangeEvent, useState} from "react";

export const useInputHandler = <T> (data: T) => {
    const [payload, setData] = useState<T|any>(data);

    const handleChange = (event: ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        const name = event.currentTarget.name;
        const value = event.currentTarget.value;
        setData((prevState: any) => ({...prevState, [name]: value}));
    }
    const handleFormChange = (event: ChangeEvent<HTMLFormElement>) => {
        const name = event.target.name;
        const value = event.target.value;
        const checked = event.target?.checked;
        setData((prevState: any) => ({...prevState, [name]: value}));
       
    }
    return {payload, handleChange, handleFormChange, setData}
}